import React from "react";
import { Box } from "@mui/material";

type Props = {
  src: string;
  size?: number;
  width?: number;
  height?: number;
  alt?: string;
};

/** Fixed-size Figma asset. Width and height required so intrinsic SVG size cannot blow up. */
export default function FacilityNetworkFigmaIcon({
  src,
  size = 16,
  width,
  height,
  alt = "",
}: Props) {
  const boxWidth = width ?? size;
  const boxHeight = height ?? size;
  return (
    <Box
      sx={{
        width: boxWidth,
        height: boxHeight,
        overflow: "hidden",
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{ width: "100%", height: "100%", display: "block", objectFit: "contain" }}
      />
    </Box>
  );
}
